module.exports = __webpack_public_path__ + "fonts/righthand-regulardash-personal.c71ca5ca.ttf";